import React, { Dispatch, SetStateAction, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, ModalProps } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { toast } from 'react-toastify';
import { useCreateOrganizationMutation } from 'src/redux/services/centralApi';

interface IAddOrganizationForm {
	name: string;
}

export default function CreateOrganization(
	{
		modalProps,
		onFinishAddOrganizationForm: outter_onFinishAddOrganizationForm,
		OpenButton,
	}: {
		onFinishAddOrganizationForm?: (params: {
			setOpen: Dispatch<SetStateAction<boolean>>
			values: IAddOrganizationForm
			form: FormInstance<IAddOrganizationForm>
		}) => void
		modalProps?: (
			params: {
				setOpen: Dispatch<SetStateAction<boolean>>
				form: FormInstance<IAddOrganizationForm>
			}
		) => ModalProps
		OpenButton?: React.FunctionComponent<{
			setOpen: Dispatch<SetStateAction<boolean>>
			form: FormInstance<IAddOrganizationForm>
		}>
		Extra?: React.FunctionComponent<{
			setOpen: Dispatch<SetStateAction<boolean>>
			form: FormInstance<IAddOrganizationForm>
		}>
	}
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ postOrganization, postOrganizationResult, ] = useCreateOrganizationMutation();
	const [ addOrganizationForm, ] = Form.useForm<IAddOrganizationForm>();

	const onFinishAddOrganizationForm = (data: IAddOrganizationForm) => {
		if(outter_onFinishAddOrganizationForm){
			outter_onFinishAddOrganizationForm({
				values: data,
				setOpen,
				form: addOrganizationForm,
			});
			return;
		}
		postOrganization({
			name: data.name,
		})
			.unwrap()
			.then(() => {
				setOpen(false);
				addOrganizationForm.resetFields();
				toast.success('Organização adicionada com sucesso!', {
					autoClose: 1000,
				});
			})
			.catch((err) => {
				if (err?.status && err?.status === 500
					&& err?.data?.frontend_message) {
					toast.error(err?.data?.frontend_message, {
						autoClose: 1000,
					});
				}
			});
	};

	return <>
		{
			OpenButton
				? <OpenButton setOpen={setOpen} form={addOrganizationForm} />
				: <Button
					type="primary"
					onClick={() => {
						setOpen(!open);
					}}
					icon={<PlusOutlined />}
				>
					Adicionar
				</Button>
		}
		<Modal
			centered
			title={'Adicionar Organização'}
			open={open}
			onCancel={() => {
				setOpen(!open);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			confirmLoading={postOrganizationResult.isLoading}
			okText="Salvar"
			onOk={() => {
				addOrganizationForm.submit();
			}}
			{ ...(
				modalProps
					? modalProps({ setOpen, form: addOrganizationForm, })
					: undefined
			) }
		>
			<Form
				layout="vertical"
				onFinish={onFinishAddOrganizationForm}
				form={addOrganizationForm}
				style={{ marginTop: 10, }}
			>
				<Form.Item
					name={'name'}
					hasFeedback
					required
					tooltip={'Insira o nome da organização.'}
					label={'Nome da organização'}
					rules={[
						{
							required: true,
							message: 'Campo obrigatório.',
						},
					]}
				>
					<Input placeholder="Nome da organização" />
				</Form.Item>
			</Form>
		</Modal>
	</>;
}